import React from 'react';

import 'echarts-wordcloud';

import { CHART_COLORS } from 'shared/constants/colors';
import Chart from './Chart';

const color = () => CHART_COLORS[Math.floor(Math.random() * CHART_COLORS.length)];

const WordCloudChart = (props) => {
  const { height, data = [] } = props;
  const options = {
    series: [{
      type: 'wordCloud',
      data: data.slice(0, 100),
      gridSize: 2,
      sizeRange: [20, 100],
      rotationRange: [-90, 90],
      rotationStep: 45,
      shape: 'pentagon',
      left: 'center',
      top: 'center',
      width: '70%',
      height: '80%',
      drawOutOfBound: false,
      layoutAnimation: true,
      textStyle: {
        color,
      },
      emphasis: {
        focus: 'self',
      },
    }],
  };

  const addToReport = props.addToReport && (() => {
    props.addToReport({
      chartSettings: {
        fieldResultType: 'wordcloud',
      },
    });
  });

  return (
    <Chart
      option={options}
      height={height}
      toolbox={{
        addToReport,
      }}
    />
  );
};

export default WordCloudChart;
